import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoJsDirective } from './video-js.directive';

@NgModule({
  declarations: [VideoJsDirective],
  imports: [
    CommonModule
  ],
  exports:[VideoJsDirective]
})
export class VideoJsModule { }
